import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const OAuthCallback = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const connected = searchParams.get('connected');
    const error = searchParams.get('error');

    // Check if we're in a popup window
    if (window.opener) {
      // We're in a popup - send message to parent and close
      if (connected === 'true') {
        window.opener.postMessage({ type: 'OAUTH_SUCCESS' }, '*');
      } else if (error) {
        window.opener.postMessage({ type: 'OAUTH_ERROR', error }, '*');
      }
      
      // Close popup after a short delay
      setTimeout(() => {
        window.close();
      }, 500);
    } else {
      // Not in popup - redirect to settings (normal flow)
      if (connected === 'true' || error) {
        window.location.href = '/settings';
      }
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-indigo-600 mx-auto mb-4"></div>
        <p className="text-lg text-slate-600">
          {searchParams.get('connected') === 'true' 
            ? 'Connection successful! Closing window...' 
            : searchParams.get('error')
            ? 'Connection failed. Closing window...'
            : 'Processing OAuth callback...'}
        </p>
      </div>
    </div>
  );
};

export default OAuthCallback;
